import { render } from "./AuthorComponent.vue?vue&type=template&id=c2fa4356&scoped=true"
import script from "./AuthorComponent.vue?vue&type=script&lang=js"
export * from "./AuthorComponent.vue?vue&type=script&lang=js"

import "./AuthorComponent.vue?vue&type=style&index=0&id=c2fa4356&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2fa4356"]])

export default __exports__